import type { ReportExportStatus, ReportType } from '@linka/domain/enums';
import { atom } from 'jotai';

export const exportChartAtom = atom<ReportType | null>(null);
export const exportDataAtom = atom<{ exportId: string; status: ReportExportStatus } | null>(null);
